import React from "react";
import axios from "../../services/axios";
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";
import AddCategoryDesafios from "../../components/desafiosPicantes/modals/addCategory";
import useAuth from "../../hooks/useAuth";
import { useCategories } from "../../hooks/database";

import Header, {
  NoHeaderScroll,
  BackHeaderLeft,
} from "../../components/navigation/header";
import Spinner from "../../components/utils/spinner";
import { CardCategoriaDesafiosEdit } from "../../components/desafiosPicantes/cardCategoria";
import { AddCategory } from "../../components/customChallenges/cards";
import { useDispatch } from "react-redux";
import { setVisible, setTitle } from "../../store/slices/customCategory";

function HeaderLeft() {
  const navigate = useNavigate();
  const handlePress = () => {
    navigate("/hot-challenges");
  };
  return <BackHeaderLeft onClick={handlePress} />;
}

export default function DesafiosPlayerCategories() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { user } = useAuth();
  const [categories, reload] = useCategories();
  const dispatch = useDispatch();

  const handleClick = (category) => {
    navigate("/hot-challenges/player-challenges", {
      state: { category },
    });
  };

  const handleAddClick = () => {
    dispatch(setTitle(""));
    dispatch(setVisible(true));
  };

  const handleSave = ({ title }) => {
    if (title) {
      axios
        .post("/categories/customCategory", {
          id_usuario: user.id_usuario,
          title: title,
        })
        .then((response) => {
          reload();
        });
    }
  };

  return (
    <div className="container no-scroll mx-auto">
      <Header
        HeaderLeft={HeaderLeft}
        HeaderCenter={() => {
          return (
            <h1 className="text-xl font-extrabold">{t("novaCategoria")}</h1>
          );
        }}
      />
      <NoHeaderScroll className="ps-12 pe-12">
        {!categories?.length ? (
          <div className="flex justify-center">
            <Spinner />
          </div>
        ) : (
          <div>
            {categories.map((category, index) => (
              <CardCategoriaDesafiosEdit
                key={`category-${index}`}
                index={index}
                category={category}
                onClick={handleClick}
              />
            ))}
          </div>
        )}
        <div className="absolute bottom-10 right-5">
          <AddCategory onClick={handleAddClick} index={categories.length} />
        </div>
        <AddCategoryDesafios onSave={handleSave} />
      </NoHeaderScroll>
    </div>
  );
}
